module.exports = "/_next/static/images/icon-threads-4b07f06bb59976818bd2f0fea1ea7e4c.svg";